/**
 * defa.views.InsuranceCompanyCollectionView
 * A view to list several InsuranceCompanys with.
 * @version 1.2.0
 */
import RadioButton    from 'scripts/defa/basic/view-radio-button-view';
import CollectionView from 'scripts/poppet/collection-view';

const InsuranceCompanyCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: RadioButton,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default InsuranceCompanyCollectionView;